import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "none",
  viewBox: "0 0 100 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 0h100",
      class: "i-1176843455__menu-line-top",
      "vector-effect": "non-scaling-stroke"
    }, null, -1),
    _createElementVNode("path", {
      d: "M0 10h100",
      class: "i-1176843455__menu-line-middle",
      "vector-effect": "non-scaling-stroke"
    }, null, -1),
    _createElementVNode("path", {
      d: "M0 20h100",
      class: "i-1176843455__menu-line-bottom",
      "vector-effect": "non-scaling-stroke"
    }, null, -1)
  ]))]))
}
export default { render: render }